<template>
  <div class="note-page">
    <div class="note-content">
      <div style="position: relative">
        <div class="nav-right">
          <a-select
            :defaultValue.sync="noteTypesKey"
            style="width: 150px; margin-right: 10px"
            @change="handleChangeNoteTypes"
          >
            <a-select-option
              v-for="(item, index) in noteTypes"
              :value="item.key"
              >{{ item.value }}</a-select-option
            >
          </a-select>
          <a-select
            defaultValue="0"
            style="width: 200px"
            @change="handleChange"
          >
            <a-select-option value="0">全部时间</a-select-option>
            <a-select-option value="1">近一周</a-select-option>
            <a-select-option value="2">近30天</a-select-option>
            <a-select-option value="3">近三个月</a-select-option>
            <a-select-option value="4">半年</a-select-option>
            <a-select-option value="5">一年</a-select-option>
          </a-select>
        </div>
        <a-tabs defaultActiveKey="0" @change="callback">
          <a-tab-pane tab="全部消息" key="0"></a-tab-pane>
          <a-tab-pane tab="未读消息" key="2"></a-tab-pane>
          <!--<a-tab-pane tab="系统消息" key="1"></a-tab-pane>-->
          <a-tab-pane tab="已读消息" key="3"></a-tab-pane>
        </a-tabs>

        <!-- <div class="page-content">
				   <a-table
					 class="hospital-table"
					 :rowSelection="rowSelection"
					 :dataSource="noteData"
					 :pagination="false"
					 :customRow="customRow"
					 size="middle"
				   >
					<a-table-column :width="130" data-index="title" key="title">
					 <span class="hospital-required table-th" slot="title">协作组条码</span>
					 <template slot-scope="text, record">
					   <span class="note-title-center">{{record.messageTitleTypeDict}}</span><br>
					   <span  class="note-title-bottom" style="margin: -5px 0;width: 130px">{{record.messageContent}}</span>
					 </template>
				   </a-table-column>
					<a-table-column :width="130" data-index="messageType" key="messageType">

				   <template slot-scope="text, record">
					 <span v-if="record.messageType==2" class="note-title-top" >待办消息</span>
					 <span v-if="record.messageType==1" class="note-title-top" >系统消息</span>
				   </template>
				 </a-table-column>
				 <a-table-column :width="130" data-index="hosBarCode" key="hosBarCode">
				   <span class="hospital-required table-th" slot="title">协作组条码</span>
				   <template slot-scope="text, record">
					 <span >{{record.hosBarCode}}</span>
				   </template>
				 </a-table-column>
				 </a-table>
				   <div class="pagination">
					 <a-pagination
					   @change="pageChange"
					   :pageSize.sync="pageSize"
					   v-model="page"
					   size="small"
					   :total="resData.total"
					 />
				   </div>
				 </div> -->
        <div class="note-list" v-if="noteData.length > 0">
          <div class="default"></div>
          <div
            class="note-item"
            style="cursor: pointer"
            v-for="(item, index) in noteData"
            :key="index"
          >
            <div class="note-contain">
              <div class="note-input">
                <!-- <a-checkbox  v-model="checkModel" :value="item.id"></a-checkbox> -->
                　　　　<input
                  type="checkbox"
                  v-model="checkModel"
                  :value="item.id"
                />
              </div>
              <!-- <div class="note-radio">
							</div> -->
              <div :class="(item.messageTitleType == 22 || item.messageTitleType == 23)?'note-title':'note-title note-text-dline'" @click="message(item)">
                <template
                  v-if="
                    item.messageTitleType == 22 || item.messageTitleType == 23
                  "
                >
                  <div v-html="mdMessageContentHtml(item)"></div>
                </template>
                <template v-else>
                  <span class="note-title-center">
                    {{ item.messageTitleTypeDict }}
                  </span>
                  <span class="note-title-bottom">
                    {{ item.messageContent }}
                  </span>
                </template>
              </div>
              <div class="note-title-top" @click="message(item)">
                <span class="note-title-top">
                  <span v-if="item.messageType == 1">系统消息</span>
                  <span v-else-if="item.messageType == 3">MD信息</span>
                  <span v-else>业务消息</span>
                </span>
              </div>
              <div class="note-time" @click="message(item)">
                {{ item.createTime }}
              </div>
              <div class="note-reply" v-if="item.messageType == 3">
                <md-to-popreply
                  :recordItem="item"
                  :text="popreplyText1"
                  @update="update"
                ></md-to-popreply>
              </div>
            </div>

            <div class="note-line"></div>
          </div>
        </div>
        <div class="note-list note-image" v-if="noteData.length <= 0"></div>
        <div class="page-bom" v-if="noteData.length > 0">
          <div class="left">
            <!-- <a-checkbox  @click="checkAll" v-model="ischecked">全选</a-checkbox> -->
            <input type="checkbox" @click="checkAll" v-model="ischecked" />全选
            <a-button type="danger" @click="dele()">删除</a-button>
            <a-button v-if="tkey != 3" type="danger" @click="setDone()"
              >已读</a-button
            >
          </div>
          <div class="right">
            <a-pagination
              @change="pageChange"
              :pageSize.sync="pageSize"
              v-model="page"
              size="small"
              :total="resData.total"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import MdToPopreply from "../report/md-to-popreply";
export default {
  components: { MdToPopreply },
  data() {
    return {
      popreplyText1: "回复",
      data: [],
      ischecked: false, //是否全选
      tkey: 0,
      optTimeRange: 0,
      messageType: 0,
      checkModel: [], //双向数据绑定的数组，我是用的id
      page: 1,
      resData: "",
      selectArr: [],
      selectIds: [],
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      current: 1,
      pageSize: 10,
      total: 50,
      userid: this.$db.get("userInfo").userId,
      noteData: [],
      noteTypes: [],
      noteTypesKey: 0,
      searchData: {
        pageSize: this.pageSize,
        pageNum: this.page,
        userId: this.userid,
        optTimeRange: this.optTimeRange,
      },
    };
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        onChange: (selectedRowKeys, selectedRows) => {},
        getCheckboxProps: (record) => ({
          props: {
            disabled: record.name === "Disabled User", // Column configuration not to be checked
            name: record.name,
          },
        }),
      };
    },
  },
  watch: {
    checkModel() {
      if (this.noteData.length > 0) {
        if (this.checkModel.length == this.noteData.length) {
          this.ischecked = true;
        } else {
          this.ischecked = false;
        }
      }
    },
  },
  methods: {
    update() {},
    // 点击消息
    message(item) {
      if (item) {
        if (item.messageTitleType) {
          if (item.messageTitleType) {
            this.setRead(item.id);
            if (item.messageTitleType == 13) {
              this.$router.push({
                path: "/sufferer",
              });
            } else if (
              item.messageTitleType == 2 ||
              item.messageTitleType == 4 ||
              item.messageTitleType == 5 ||
              item.messageTitleType == 17 ||
              item.messageTitleType == 19 ||
              item.messageTitleType == 20
            ) {
              this.$router.push({
                path: "/diagnosis/details",
                query: {
                  id: item.bid,
                },
              });
            } else if (item.messageTitleType == 6) {
              this.$router.push({
                path: "/sample",
              });
            } else if (
              item.messageTitleType == 7 ||
              item.messageTitleType == 8 ||
              item.messageTitleType == 15 ||
              item.messageTitleType == 21
            ) {
              this.$router.push({
                path: "/job/details",
                query: {
                  id: item.bid,
                },
              });
            } else if (
              item.messageTitleType == 9 ||
              item.messageTitleType == 10 ||
              item.messageTitleType == 11 ||
              item.messageTitleType == 12 ||
              item.messageTitleType == 16
            ) {
              this.$router.push({
                path: "/report/details",
                query: {
                  id: item.bid,
                },
              });
            } else if (item.messageTitleType == 3) {
              this.$router.push({
                path: "/sufferer/detail",
                query: {
                  id: item.bid,
                },
              });
            }
          }
        }
      }
    },
    mdMessageContentHtml(item) {
      let html = [];
      let splitContent = item.messageContent
        ? item.messageContent.split("#$%")
        : [];
      if (item.messageTitleType == 22) {
        html.push(
          "<div class='note-title-center'>" +
            item.messageTitleTypeDict +
            "</div>"
        );
        html.push("<div class='note-title-bottom'>");
        html.push(
          "<i class='note-t-b-c1'>审核了协作组条码为" +
            splitContent[0] +
            "的样本：</i>"
        );
        if (splitContent.length > 1) {
          html.push("<i class='note-t-b-c2'>" + splitContent[1] + "</i>");
        }
        html.push("</div>");
      } else {
        if (splitContent.length == 1) {
          html.push(
            "<div class='note-title-center'>" + splitContent[0] + "</div>"
          );
        } else {
          html.push(
            "<div class='note-title-center'>" + splitContent[0] + "</div>"
          );
          html.push("<div class='note-title-bottom'>");
          html.push("<i class='note-t-b-c1'>回复了你的MD审核：</i>");
          html.push("<i class='note-t-b-c2'>" + splitContent[1] + "</i>");
          html.push("</div>");
          html.push("<div class='note-title-bottom'>");
          html.push("<i class='note-t-b-c1'>“" + splitContent[2] + "”");
          html.push("——" + splitContent[3] + "</i>");
          html.push("</div>");
        }
      }
      return html.join(" ");
    },
    setRead(ids) {
      if (ids) {
        this.$put("/message", {
          ids: ids,
        }).then((res) => {
          console.log("消息通知已读成功");
        });
      }
    },
    setDone() {
      let tag = JSON.parse(JSON.stringify(this.checkModel));
      let str = tag.join(",");
      if (this.checkModel.length > 0) {
        this.$put("/message", {
          ids: str,
        }).then((res) => {
          this.page = 1;
          let data = {
            pageSize: this.pageSize,
            pageNum: this.page,
            userId: this.userid,
            optTimeRange: this.optTimeRange,
          };
          this.getNoteData(data);
          this.$message.success("消息通知已读成功");
        });
      } else {
        this.$message.error("请选择至少一条消息");
      }
    },
    dele() {
      let tag = JSON.parse(JSON.stringify(this.checkModel));
      let str = tag.join(",");
      if (this.checkModel.length > 0) {
        this.$delete("/message", {
          ids: str,
        }).then((res) => {
          // let data = JSON.parse(JSON.stringify(this.searchData))
          this.page = 1;
          let data = {
            pageSize: this.pageSize,
            pageNum: this.page,
            userId: this.userid,
            optTimeRange: this.optTimeRange,
          };
          this.getNoteData(data);
        });
      } else {
        this.$message.error("请选择至少一条消息");
      }
    },
    checkAll() {
      if (this.ischecked) {
        this.checkModel = [];
      } else {
        this.noteData.forEach((item) => {
          if (this.checkModel.indexOf(item.id) == -1) {
            this.checkModel.push(item.id);
          }
        });
      }
    },
    callback(key) {
      this.tkey = key;
      this.page = 1;
      let data = {};
      if (this.tkey == 0) {
        data = {
          pageSize: this.pageSize,
          pageNum: this.page,
          userId: this.userid,
          optTimeRange: this.optTimeRange,
        };
      } else if (this.tkey == 3) {
        data = {
          pageSize: this.pageSize,
          pageNum: this.page,
          userId: this.userid,
          messageStatus: 1,
          optTimeRange: this.optTimeRange,
        };
      } else {
        data = {
          pageSize: this.pageSize,
          pageNum: this.page,
          userId: this.userid,
          messageStatus: 0,
          optTimeRange: this.optTimeRange,
        };
      }
      // let data = JSON.parse(JSON.stringify(this.searchData))
      this.getNoteData(data);
    },
    handleChange(value) {
      this.page = 1;
      this.optTimeRange = value;
      let data = {
        pageSize: this.pageSize,
        pageNum: this.page,
        userId: this.userid,
        optTimeRange: this.optTimeRange,
      };
      this.getNoteData(data);
    },
    handleChangeNoteTypes(value) {
      this.page = 1;
      this.messageType = value;
      let data = {
        pageSize: this.pageSize,
        pageNum: this.page,
        userId: this.userid,
        optTimeRange: this.optTimeRange,
        messageType: this.messageType,
      };
      this.getNoteData(data);
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize;
    },
    pageChange(page, pagesize) {
      this.page = page;
      this.pageSize = pagesize;
      let data = {
        pageSize: this.pageSize,
        pageNum: this.page,
        userId: this.userid,
        optTimeRange: this.optTimeRange,
      };
      // let data = JSON.parse(JSON.stringify(this.searchData))
      this.getNoteData(data);
    },
    getNoteData(data) {
      if (data.messageType == 0) {
        delete data.messageType;
      }
      this.$get("/message/page", data).then((res) => {
        this.noteData = res.data.data.rows;
        this.resData = res.data.data;
        // this.data = this.resData.rows;
      });
    },
    getTypes() {
      this.$get("/message/getTypes").then((res) => {
        this.noteTypes = res.data.data;
        this.noteTypes.push({ key: 0, value: "全部" });
      });
    },
  },
  mounted() {
    this.$store.state.account.isActive = false;
    let data = {
      pageSize: this.pageSize,
      pageNum: this.page,
      userId: this.userid,
      optTimeRange: this.optTimeRange,
    };
    this.getNoteData(data);
    this.getTypes();
  },
};
</script>
<style>
.note-page .ant-tabs-nav .ant-tabs-tab {
  padding: 22px 16px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(157, 164, 173, 1);
}

.note-page .ant-tabs-nav .ant-tabs-tab-active {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(62, 127, 255, 1);
}

.note-page .ant-tabs-ink-bar {
  width: 74px;
  height: 6px;
  background: rgba(62, 127, 255, 1);
}
</style>

<style lang="scss" scoped>
.note-page {
  width: 1200px;
  margin: 0 auto;
}

.nav-right {
  position: absolute;
  right: 30px;
  top: 20px;
  z-index: 9;
}

.page-bom {
  // padding-top:30px;
  width: 960px;
  margin: 24px auto 0;
  display: flex;
  justify-content: space-between;
  align-content: center;
  input {
    margin: 0 20px;
  }
  button {
    margin-left: 20px;
    background: red;
    color: #fff;
  }
}

input {
  width: 14px;
  height: 14px;
  border: 1px solid rgba(231, 235, 236, 1);
  border-radius: 2px;
}

.pagination {
  margin: 20px 0;
  text-align: right;
}

.note-content {
  width: 100%;
  background: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.08);
  margin: 0 auto;
  padding: 58px 70px 24px 70px;
  .nav {
    clear: both;
    padding-top: 10px;
    width: 960px;
    margin: 0 auto;
    .nav-left {
      float: left;
      span {
        margin-right: 20px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(60, 60, 60, 1);
      }
      .ant-btn {
        margin-left: 22px;
      }
    }
  }

  .note-list {
    width: 960px;
    margin: 10px auto 0;
    min-height: 922px;
    border: 1px solid rgba(225, 226, 229, 1);
    clear: both;
    .note-item {
      padding: 20px 21px 0 21px;
      vertical-align: middle;
    }
    .note-contain {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    // .note-item:before,
    // .note-item:after    /* :after 可以不需要 */
    // {
    //     display: inline-block;
    //     vertical-align: middle;
    //     content: '';
    // }
    .note-input {
      display: inline-block;
      vertical-align: middle;
      margin-right: 10px;
      margin-top: 8px;
    }
    .note-radio {
      width: 10px;
      height: 10px;
      background: rgba(255, 0, 1, 1);
      border-radius: 50%;
      display: inline-block;
      vertical-align: middle;
      margin: 0 10px;
    }
    .note-title {
      display: inline-block;
      width: 560px;
      margin-right: 10px;
      vertical-align: middle;
      span {
        display: block;
      }
      &.note-text-dline {
        /deep/ .note-title-bottom {
          text-decoration-line: underline;
        }
        // /deep/ .note-title-bottom:hover{
        //   color: #428ef7;
        // }
      }
    }
    .note-title-top {
      font-size: 14px;
      // margin-bottom: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(164, 164, 164, 1);
    }
    /deep/ .note-title-center {
      font-size: 14px;
      margin-bottom: 10px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #162232;
    }
    /deep/ .note-title-bottom {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(60, 60, 60, 1);
      .note-t-b-c1 {
        color: #9b9b9b;
        font-style: inherit;
      }
      .note-t-b-c2 {
        color: #162232;
        font-style: inherit;
      }
    }
    .note-time {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      margin-left: 60px;
      color: rgba(164, 164, 164, 1);
      display: inline-block;
      vertical-align: top;
    }

    .note-line {
      height: 1px;
      margin-top: 25px;
      border-bottom: 1px dashed rgba(157, 164, 173, 1);
    }
    .note-item:last-child {
      .note-line {
        border-color: #fff;
      }
    }
  }
  .note-image {
    background: url("../../assets/image/common/shujukong.png") no-repeat center
      200px;
    overflow: hidden;
  }
  .page-pag {
    width: 960px;
    margin: 20px auto;
    padding-bottom: 40px;
    .ant-pagination {
      float: right;
    }
  }
}
</style>